import styled from '@emotion/styled';
import { COLORS, mediaMax, breakpoints } from 'styles';
import SecondaryButton from 'components/ui/buttons/SecondaryButton';

export const Text = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 150%;
  text-indent: 20px;
  color: ${COLORS.SECONDARY_TEXT};

  ${mediaMax(breakpoints.tabletXS)} {
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 18.2px;
  }

  &:first-of-type {
    margin-top: 32px;
    margin-bottom: 40px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  ${mediaMax(breakpoints.tabletXS)} {
    &:first-of-type {
      margin-top: 15px;
      margin-bottom: 11px;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;
  margin-bottom: 10px;

  & fieldset {
    top: 0;

    legend {
      position: fixed;
      z-index: -1;
      width: 0;
      height: 0;
      overflow: hidden;
      top: -9999px;
      left: -9999px;
    }
  }

  ${mediaMax(breakpoints.tabletXS)} {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;

export const ButtonWrapper = styled.div`
  min-width: 243px;

  ${mediaMax(breakpoints.tabletXS)} {
    width: 100%;
  }
`;

export const SubmitButton = styled(SecondaryButton)`
  word-break: keep-all;
  ${mediaMax(breakpoints.tabletXS)} {
    width: 100%;
  }
`;

export const InputLabel = styled.label`
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
`;

export const Link = styled.a`
  font-weight: 500;
  color: ${COLORS.BLUE500};
  cursor: pointer;

  text-decoration: unset;
`;
